import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'filterOutCustomDeviceBomModel',
    standalone: false
})
export class IsCustomDeviceBomModelPipe implements PipeTransform {

  transform(bomModels: IBomModel[], isCustomDevice: boolean): IBomModel[] {
    return bomModels?.filter(m => m.article.isCustomDevice === isCustomDevice);
  }
}
